import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { TRIGGER_CHART_TYPES } from '/src/features/goals/constants';
import { SPECIAL_DATE_RANGES } from '../_global/constants';
import { JSON_DATE_RANGE_ADAPTER } from '/src/utils/date-range-adapters';

function getDefaultGoalDateSelection() {
  return {
    special: SPECIAL_DATE_RANGES.RECENT,
    startDate: null,
    endDate: null,
  };
}

export const goalSelectedDatesAtom = atomWithDefault(() => {
  const params = new URLSearchParams(window.location.search);
  const parsed = JSON_DATE_RANGE_ADAPTER.parse(params.get('date'));

  if (parsed.status !== 'valid') {
    return getDefaultGoalDateSelection();
  }

  if (parsed.value.special) {
    return {
      special: parsed.value.special,
      startDate: null,
      endDate: null,
    };
  }

  return {
    special: null,
    startDate: Math.floor(parsed.value.start_date.getTime() / 1000),
    endDate: Math.floor(parsed.value.end_date.getTime() / 1000),
  };
});

export const goalDetailSelectedTriggerType = atom(TRIGGER_CHART_TYPES.SEPARATE);
